import React from "react";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import { ChevronRight, Close } from "assets/icons";
import Tooltip from "components/tooltips/Tooltips";
import {
    TEMPLATE_STEPS,
    TEMPLATE_STEPS_COUNT,
    getTemplateStepLabel,
} from "pages/missionTemplates/templateSteps";

const TemplateSubNav = () => {
    const { toggle } = useModal();
    const { templatePage, setTemplatePage, language } = UseContext();

    // Same confirmation as everywhere else in the app: a modal, not the browser's dialog.
    const handleClose = (e) => {
        e.preventDefault();
        toggle("mt_close_process");
    };

    const goToStep = (zeroBasedIndex) => {
        const step = zeroBasedIndex + 1;
        if (step < 1 || step > TEMPLATE_STEPS_COUNT) return;
        if (zeroBasedIndex >= templatePage - 1) return;
        setTemplatePage(step);
    };

    if (templatePage <= 0 || templatePage > TEMPLATE_STEPS_COUNT) {
        return null;
    }

    return (
        <div
            className={
                "flex justify-between px-5 gap-3 border-b border-gray-100 select-none min-h-[66px] max-h-[66px]"
            }
        >
            <div
                className={
                    "my-auto flex gap-1 whitespace-nowrap overflow-x-auto no-scrollbar ft-sm pr-5 py-4"
                }
            >
                {TEMPLATE_STEPS.map((step, index) => {
                    const label = getTemplateStepLabel(language, step);
                    const isCurrent = templatePage - 1 === index;
                    const isVisitedPast = templatePage - 1 > index;
                    const clickable = isVisitedPast;

                    const tabClassName = `my-auto py-2 px-3 border rounded-lg text-left ${
                        isCurrent
                            ? "bg-yellow-50 border-yellow-300 text-yellow-500"
                            : isVisitedPast
                              ? "bg-yellow-50 text-yellow-500 border-white"
                              : "bg-gray-50 border-white"
                    } ${clickable ? "cursor-pointer hover:bg-yellow-100/80 transition-colors" : ""}`;

                    return (
                    <div key={step.key} className={"flex items-center gap-1"}>
                        {clickable ? (
                            <button
                                type="button"
                                className={tabClassName}
                                onClick={() => goToStep(index)}
                                title={language.getValue(
                                    "missionTemplate.wizard.backToStep",
                                    "Revenir à cette étape"
                                )}
                            >
                                {label}
                            </button>
                        ) : (
                            <div className={tabClassName}>
                                {label}
                            </div>
                        )}
                        {index < TEMPLATE_STEPS_COUNT - 1 && (
                            <div className={"my-auto"}>
                                <ChevronRight wh={16} color={"#6B7280"} />
                            </div>
                        )}
                    </div>
                    );
                })}
            </div>
            <div className={"my-auto flex gap-2 py-4 border-l border-gray-100 pl-3"}>
                <Tooltip
                    text={language.getValue(
                        "missionTemplate.wizard.leaveTooltip",
                        "Quitter"
                    )}
                    placement="bottom"
                >
                    <button
                        type="button"
                        className={
                            "cursor-pointer border rounded p-1 hover:bg-gray-50"
                        }
                        onClick={handleClose}
                        aria-label={language.getValue(
                            "missionTemplate.wizard.leaveLabel",
                            "Quitter la création de fiche de poste"
                        )}
                    >
                        <Close wh={20} color={"#374151"} />
                    </button>
                </Tooltip>
            </div>
        </div>
    );
};

export default TemplateSubNav;
